import SafeImage from 'components/SafeImage';
import { Box } from '@mui/material';
import { deprecatedColors } from 'styles/theme/deprecatedColors';

type PreviewImageProps = {
    index: number;
    image: string;
    imageSize: number;
    currentImage: number;
    setCurrentIndex: (index: number) => void;
    currentIndex: number;
};

export function PreviewImage(props: PreviewImageProps) {
    const { index, image, imageSize, currentImage, setCurrentIndex, currentIndex } = props;

    const onClick = () => {
        if (currentIndex > 1) {
            // If the left image (Index 0) is selected index - 1 sets currentIndex to currentIndex + -1
            // If the right image (Index 2) is selected index - 1 sets currentIndex to currentIndex + 1
            setCurrentIndex(currentIndex - 1 + index);

            return;
        }

        setCurrentIndex(index);
    };

    return (
        <Box
            key={index}
            sx={{
                margin: '20px 10px',
                cursor: 'pointer',
                border: index === currentImage ? `1px solid ${deprecatedColors.secondary2}` : 'none',
            }}
            onClick={onClick}
        >
            <SafeImage
                alt="preview image"
                src={image}
                blurDataURL={image}
                placeholder="blur"
                width={imageSize * 0.40}
                height={imageSize * 0.40}
            />
        </Box>
    );
}
